const clientId = 'bc9f19865886496ba56b35e44e6b2304';
//const redirectUri = 'http://localhost:3000'; //redirect used for local dev
const redirectUri = 'https://cc-jammming-reactpractice.netlify.app/'; // redirect for livebranch
let accessToken;

const Spotify = {

    getAccessToken() {
         if (accessToken) {
            return accessToken;
         }

         const accessTokenMatch = window.location.href.match(/access_token=([^&]*)/);
         const expiresInMatch = window.location.href.match(/expires_in=([^&]*)/);

         if (accessTokenMatch && expiresInMatch) {
            accessToken = accessTokenMatch[1];
            const expiresIn = Number(expiresInMatch[1]);

            window.setTimeout(() => accessToken = '', expiresIn * 1000);
            window.history.pushState('Access Token', null, '/'); //clears params so that a new token can be initalised upon expiry

            return accessToken;
         } else {
            const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectUri}`;
            window.location = accessUrl;
         }
    },
    search(term) {
            const accessToken = Spotify.getAccessToken();
            return fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }).then(response => {
              return response.json();
            }).then(jsonResponse => {
              if (!jsonResponse.tracks) {
                return [];
              }
              return jsonResponse.tracks.items.map(track => ({
                id: track.id,
                name: track.name,
                artist: track.artists[0].name,
                album: track.album.name,
                uri: track.uri
              }));
            });

    },
    savePlaylist(name, trackUris) {
        if (!name || !trackUris.length) {
            return;
        }

        const accessToken = Spotify.getAccessToken();
        const headers = { Authorization: `Bearer ${accessToken}` };
        let userId;

        return fetch('https://api.spotify.com/v1/me', {headers: headers})
                .then(response => response.json())
                .then(jsonResponse => {
                    userId = jsonResponse.id;
                    return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
                        headers: headers,
                        method: 'POST',
                        body: JSON.stringify({name: name})
                    })
                    .then(response => response.json()
                    ).then(jsonResponse => {
                      const playlistId = jsonResponse.id;
                      return fetch(`https://api.spotify.com/v1/users/${userId}/playlists/${playlistId}/tracks`, {
                        headers: headers,
                        method: 'POST',
                        body: JSON.stringify({uris: trackUris})
                      });
                    });
                });
    },
    getTrackPreview(trackID) {
        const accessToken = Spotify.getAccessToken();
        const headers = { Authorization: `Bearer ${accessToken}` };

        return fetch(`https://api.spotify.com/v1/tracks/${trackID}`, {headers: headers})
                .then(response => response.json())
                .then(jsonResponse => {
                    //console.log(jsonResponse);
                    //console.log(jsonResponse.preview_url);
                    const preview = jsonResponse.preview_url;
                    
                    let audio = new Audio(preview);
                    audio.volume = 0.25;
                    audio.play();
                })
                .catch((error) => {
                    alert(error);
                });
    }
}

export default Spotify;
